'use client';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { elowenClient } from "../elowenClient";
/** Create (or overwrite) a user sub-agent of the subagent plugin. Applies live via plugin hot-reload. */
export function useSavePluginSubagent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { name: string; def: { description: string; tools: 'read-only' | 'all' | 'inherit' | string[]; body: string; model: string } }) => elowenClient.savePluginSubagent(v.name, v.def),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['plugin-subagents'] }),
  });
}

export function useDeletePluginSubagent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => elowenClient.deletePluginSubagent(name),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['plugin-subagents'] }),
  });
}
